import * as Yup from 'yup';

// Register schema based on backend RegisterDto
export const registerSchema = Yup.object().shape({
  companyName: Yup.string()
    .min(2, 'Company name must be at least 2 characters')
    .required('Company name is required'),
  
  rif: Yup.string()
    .required('RIF is required'),
  
  contactName: Yup.string()
    .min(2, 'Contact name must be at least 2 characters')
    .required('Contact name is required'),
  
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  
  phoneNumber: Yup.string()
    .required('Phone number is required')
    // This matches international phone number format
    .test('is-phone', 'Phone must be a valid number with country code', 
      value => {
        // Basic check for international format starting with +
        return /^\+\d{12}$/.test(value);
      }),
  
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
  
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .min(8, 'Password must be at least 8 characters')
    .required('Confirm password is required'),
  
  termsAccepted: Yup.boolean()
    .oneOf([true], 'You must accept the terms and conditions')
    .required('You must accept the terms and conditions')
});

export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required')
});

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required')
});

export const createUserSchema = Yup.object().shape({
  companyName: Yup.string()
    .min(2, 'Company name must be at least 2 characters')
    .required('Company name is required'),
  
  rif: Yup.string()
    .required('RIF is required'),
  
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  
  phoneNumber: Yup.string()
    .required('Phone number is required')
    .test('is-phone', 'Phone must be a valid number with country code', 
      value => {
        return /^\+\d{12}$/.test(value);
      }),
});

export const updatePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .required('Current password is required'),
  
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('New password is required'),
  
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    .required('Confirm password is required')
});

export const forgotPasswordStepOneSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required')
});

export const forgotPasswordStepTwoSchema = Yup.object().shape({
  otp: Yup.array()
    .of(Yup.string().required('Please enter all OTP digits'))
    .length(4, 'Please enter all 4 digits of the OTP')
    .required('OTP is required')
});

export const forgotPasswordStepThreeSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    .required('Confirm password is required')
});